module.exports = __webpack_public_path__ + "img/worksbot_img20021111.f36166da.jpg";